import React, { FC } from 'react';

import styles from '../ActionModal.module.scss';

import exclamationImg from 'src/assets/images/exclamation_mark_rounded.png';

import InfoTextBlock from 'src/atoms/InfoTextBlock';
import { BlackBoxButton } from 'src/components';

type TErrorMessageProps = {
  onClick: () => void;
  message: string | null;
};

const ErrorMessage: FC<TErrorMessageProps> = ({ onClick, message = 'Something went wrong... Please try again.' }) => {
  return (
    <div style={{ width: '100%' }}>
      <div className={styles.errorMessageBlock}>
        <div className={styles.errorImgWrapper}>
          <img src={exclamationImg} alt="attention" className="img-fluid" />
        </div>

        <InfoTextBlock classes={{ wrapper: styles.errorTextWrapper }}>{message}</InfoTextBlock>
      </div>

      <BlackBoxButton type="button" label="Try again" onClick={onClick} btnClass={styles.errorMessageBtn} />
    </div>
  );
};

export default ErrorMessage;
